import React from 'react';
import { connect } from 'react-redux';

import PlanDetails from './PlanDetails';

import * as billingSelectors from '../../../../redux/auth/billing/selectors';

import * as selectors from './selectors';

const PlanDetailsConnected = (props) => <PlanDetails {...props} />;

const mapStateToProps = (state, props) => ({
  isLoading: billingSelectors.selectIsLoading(state),
  cardExpiration: billingSelectors.selectCardExpiration(state),
  cardNumber: billingSelectors.selectCardNumber(state),

  price: selectors.selectPrice(state, props),
  isCardDataEmpty: selectors.selectIsCardDataEmpty(state),
});

export default connect(mapStateToProps)(PlanDetailsConnected);
